// Tiny DOM builder. Text always goes in as text nodes, never parsed as HTML.
//   h('button', { class: 'x', onclick: fn, 'aria-label': 'Close' }, 'Close')

export function h(tag, attrs = {}, ...children) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs ?? {})) {
    if (v == null || v === false) continue;
    if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2), v);
    else if (k === 'class') el.className = v;
    else if (k === 'style' && typeof v === 'object') {
      for (const [prop, val] of Object.entries(v)) {
        if (prop.startsWith('--')) el.style.setProperty(prop, val); // custom properties need setProperty
        else el.style[prop] = val;
      }
    }
    else if (k === 'dataset') Object.assign(el.dataset, v);
    else el.setAttribute(k, v === true ? '' : String(v));
  }
  append(el, children);
  return el;
}

function append(el, children) {
  for (const c of children.flat(Infinity)) {
    if (c == null || c === false) continue;
    el.append(c instanceof Node ? c : document.createTextNode(String(c)));
  }
}

/** Static, trusted SVG markup from icons.js only. */
export function icon(svg, label) {
  const span = document.createElement('span');
  span.className = 'icon';
  span.innerHTML = svg; // constant markup from our own icons module, never data
  if (label) span.setAttribute('aria-label', label);
  else span.setAttribute('aria-hidden', 'true');
  return span;
}
